import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';

import { PopUpNotificationService } from '@core/services/popup-notification.service';
import * as GlobalAction from '@core/store/actions/global.action';
import { GlobalService } from '@core/services/global.services';
import { StorageMap } from '@ngx-pwa/local-storage';


@Injectable()
export class GlobalEffect {

  constructor(private actions$: Actions,
              private globalService: GlobalService,
              private popupService: PopUpNotificationService,
              private storage: StorageMap) {}
}
